<template>
  <div class="work-info-wrap">
    <div class="one">
      <div class="title" style="width: 30px">1</div>
      <div class="detail-wrap">
        <div class="item" style="margin-left: 0">
          <el-date-picker
            v-model="oneStartTime"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="Start Date"></el-date-picker>
        </div>
        <div class="item">
          <el-date-picker
            v-model="oneEndTime"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="End Date"></el-date-picker>
        </div>
        <div class="item">
          <el-input v-model="oneWorkPlace" placeholder="Company Name"></el-input>
        </div>
        <div class="item">
          <el-input v-model="oneWorkContent" placeholder="Designation"></el-input>
        </div>
      </div>
    </div>
    <div class="two" v-show="workInfoShows.includes('TWO')">
      <div class="title" style="width: 30px">2</div>
      <span class="delete" @click="handleDelete('TWO')">delete</span>
      <div class="detail-wrap">
        <div class="item" style="margin-left: 0">
          <el-date-picker
            v-model="twoStartTime"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="Start Date"></el-date-picker>
        </div>
        <div class="item">
          <el-date-picker
            v-model="twoEndTime"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="End Date"></el-date-picker>
        </div>
        <div class="item">
          <el-input v-model="twoWorkPlace" placeholder="Company Name"></el-input>
        </div>
        <div class="item">
          <el-input v-model="twoWorkContent" placeholder="Designation"></el-input>
        </div>
      </div>
    </div>
    <div class="three" v-show="workInfoShows.includes('THREE')">
      <div class="title" style="width: 30px">3</div>
      <span class="delete" @click="handleDelete('THREE')">delete</span>
      <div class="detail-wrap">
        <div class="item" style="margin-left: 0">
          <el-date-picker
            v-model="threeStartTime"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="Start Date"></el-date-picker>
        </div>
        <div class="item">
          <el-date-picker
            v-model="threeEndTime"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="End Date"></el-date-picker>
        </div>
        <div class="item">
          <el-input v-model="threeWorkPlace" placeholder="Company Name"></el-input>
        </div>
        <div class="item">
          <el-input v-model="threeWorkContent" placeholder="Designation"></el-input>
        </div>
      </div>
    </div>
    <div class="three" v-show="workInfoShows.includes('FOUR')">
      <div class="title" style="width: 30px">4</div>
      <span class="delete" @click="handleDelete('FOUR')">delete</span>
      <div class="detail-wrap">
        <div class="item" style="margin-left: 0">
          <el-date-picker
            v-model="fourStartTime"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="Start Date"></el-date-picker>
        </div>
        <div class="item">
          <el-date-picker
            v-model="fourEndTime"
            type="month"
            format="MM/yyyy"
            value-format="MM/yyyy"
            placeholder="End Date"></el-date-picker>
        </div>
        <div class="item">
          <el-input v-model="fourWorkPlace" placeholder="Company Name"></el-input>
        </div>
        <div class="item">
          <el-input v-model="fourWorkContent" placeholder="Designation"></el-input>
        </div>
      </div>
    </div>
    <div v-show="clickCounter < 3" class="bottom-btn">
      <el-button @click="addClickCounter" style="display:block;margin: 0 auto;width: 120px;color: #007ab0;" type="text" icon="el-icon-plus">Add working experience</el-button>
    </div>
  </div>
</template>

<script>
const TWO = 'TWO'
const THREE = 'THREE'
const FOUR = 'FOUR'
export default {
  data() {
    return {
      clickCounter: 0,
      oneStartTime: '',
      oneEndTime: '',
      oneWorkPlace: '',
      oneWorkContent: '',
      twoStartTime: '',
      twoEndTime: '',
      twoWorkPlace: '',
      twoWorkContent: '',
      threeStartTime: '',
      threeEndTime: '',
      threeWorkPlace: '',
      threeWorkContent: '',
      fourStartTime: '',
      fourEndTime: '',
      fourWorkPlace: '',
      fourWorkContent: '',
      workInfoShows: []
    }
  },
  methods: {
    addClickCounter() {
      if (!this.workInfoShows.includes(TWO)) {
        this.workInfoShows.push(TWO)
        return
      }
      if (!this.workInfoShows.includes(THREE)) {
        this.workInfoShows.push(THREE)
        return
      }
      if (!this.workInfoShows.includes(FOUR)) {
        this.workInfoShows.push(FOUR)
        return
      }
    },
    handleDelete(key) {
      switch (key) {
        case TWO:
          const i = this.workInfoShows.findIndex(t => t === key)
          this.workInfoShows.splice(i, 1)
          this.twoStartTime = ''
          this.twoEndTime = ''
          this.twoWorkContent = ''
          this.twoWorkPlace = ''
          break
        case THREE:
          const index = this.workInfoShows.findIndex(t => t === key)
          this.workInfoShows.splice(index, 1)
          this.threeStartTime = ''
          this.threeEndTime = ''
          this.threeWorkContent = ''
          this.threeWorkPlace = ''
          break
        case FOUR:
          const _index = this.workInfoShows.findIndex(t => t === key)
          this.workInfoShows.splice(_index, 1)
          this.fourStartTime = ''
          this.fourEndTime = ''
          this.fourWorkContent = ''
          this.fourWorkPlace = ''
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="stylus">
  .work-info-wrap
    margin-top 24px
    .one, .two, .three
      position relative
      display flex
      margin-bottom 24px
      .delete
        position absolute
        top 8px
        right -50px
        font-size 14px
        color #f03b3b
        cursor pointer
      .title
        width 30px
        line-height 40px
        font-size 14px
        font-weight bold
        color #333
      .detail-wrap
        flex 1
        display flex
        .item
          flex 1
          margin-left 24px
          .el-input
            width 100%
</style>



// WEBPACK FOOTER //
// src/components/work-info/work-info.vue